import React, { useEffect, useState } from 'react';
import './PrintFireRecord.less';
import * as CONF from "../../common/config";
import * as REQUEST from "../../common/request";
import moment from 'moment';

const PrintSafetyRecord = () => {
    const [recordData, setRecordData] = useState(null);
    const [list, setList] = useState([]);

    const getList = async (id) => {
        const result = await REQUEST.get({
            url: '/checkfire/get',
            data: { id },
        });
        if (!result) return;
        setRecordData(result.data);
    };

    const getProjectList = async () => {
        const result = await REQUEST.get({
            url: '/fireprint/checkprojectList',
        });
        if (!result) return;
        setList(result.data || []);
    };

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const dataStr = query.get('data');
        const data = JSON.parse(decodeURIComponent(dataStr));

        getList(data);
        getProjectList();
    }, []);

    if (!recordData) return null;

    /** ================= 工具方法 ================= */

    const normalize = str => (str || '').trim();

    const splitOptions = options =>
        normalize(options)
            .split(',')
            .map(o => o.trim())
            .filter(Boolean);

    const isChecked = (selected = '', option = '') => {
        if (!selected) return false;
        return selected
            .split(',')
            .map(s => s.trim())
            .includes(option);
    };

    const CheckedIcon = () => (
        <svg width="14" height="14" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
            <rect x="0.75" y="0.75" width="14.5" height="14.5" fill="none" stroke="#000" strokeWidth="1.5" />
            <path d="M3 8.5 L6.5 12 L13 3.5" stroke="#000" strokeWidth="2" fill="none" />
        </svg>
    );

    const UnCheckedIcon = () => (
        <svg width="14" height="14" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
            <rect x="0.75" y="0.75" width="14.5" height="14.5" fill="none" stroke="#000" strokeWidth="1.5" />
        </svg>
    );


    /** =============== list + 实际数据合并 =============== */

    // 把多个“其它”合并
    const normalizeChecklist = (checklist = []) => {
        const map = {};

        checklist.forEach(item => {
            if (item.title === '其它') {
                if (!map['其它']) {
                    map['其它'] = {
                        ...item,
                        description: item.description || '',
                    };
                } else {
                    // 合并 description
                    if (item.description) {
                        map['其它'].description += '，' + item.description;
                    }
                }
            } else {
                map[item.title] = item;
            }
        });

        return Object.values(map);
    };
    
    const mergeChecklist = (template = [], checklist = []) =>
        template.map(tpl => {
            const exist = checklist.find(item => item.title === tpl.title);

            return {
                id: tpl.id,
                title: tpl.title,
                options: Array.isArray(tpl.options)
                    ? tpl.options.join(',')
                    : tpl.options,

                selected: exist?.selected || '',
                description: exist?.description || '',
                partText: exist?.partText || '',
                oldrectifyType: exist?.oldrectifyType || null,
                selectDate: exist?.selectDate || '',

                // 后端控制字段
                descFlag: tpl.descFlag === 1 || tpl.descFlag === true,
                ispart: tpl.ispart === true,
                needOtherInput: tpl.needOtherInput === true,
                otherOptionValue: tpl.otherOptionValue || '其他',
                otherText: exist?.otherText || '',
                showDescAndImage: tpl.showDescAndImage === true
            };
        });

    const finalChecklist = mergeChecklist(
        list,
        normalizeChecklist(recordData.checklist || [])
    );
   

    /** ================= 渲染选项 ================= */

    const renderOptions = (item) => {
        const options = splitOptions(item.options);
        const selected = item.selected || '';

        return (
            <span className="options">
                {options.map(opt => {
                    const checked = isChecked(selected, opt);
                    const isOther =
                        item.needOtherInput &&
                        opt === item.otherOptionValue &&
                        checked;

                    return (
                        <span key={opt} className="option-item">
                            {checked ? <CheckedIcon /> : <UnCheckedIcon />}
                            {opt}

                            {/* 勾选“其他”时显示 otherText */}
                            {isOther && item.otherText && (
                                <span className="other-text">
                                    ({item.otherText})
                                </span>
                            )}
                        </span>
                    );
                })}
            </span>
        );
    };

    /** ================= 处理情况 ================= */

    const getItemIndexText = (type) => {
        const indexes = hazardChecklist
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.oldrectifyType == type)
            .map(item => item.index + 1);

        return indexes.length ? indexes.join('、') : '';
    };

    const getDelayInfo = () => {
        const delayItems = hazardChecklist
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.oldrectifyType === 2);

        if (!delayItems.length) {
            return {
                indexText: '',
                dateText: '',
            };
        }

        // 序号
        const indexText = delayItems
            .map(item => item.index + 1)
            .join('、');

        // 取最早的整改截止日期
        const dates = delayItems
            .map(item => item.selectDate)
            .filter(Boolean)
            .sort();

        let dateText = '';
        if (dates.length) {
            const d = new Date(dates[0]);
            dateText = `${d.getFullYear()} 年 ${String(d.getMonth() + 1).padStart(2, '0')} 月 ${String(d.getDate()).padStart(2, '0')} 日`;
        }

        return { indexText, dateText };
    };

    // 只用于“巡查内容及存在隐患”和“处理情况”的列表（去掉前两项）
    const hazardChecklist = finalChecklist.filter(
        item =>
            item.title !== '所在建筑类型' &&
            item.title !== '单位(场所)性质'
    );
    const handleText = (() => {
        const rectifyNow = getItemIndexText(1);
        const rectifyLater = getItemIndexText(2);
        const transfer = getItemIndexText(3);

        const { dateText } = getDelayInfo();

        return (
            <>
                <div className="handle-line">处理情况：</div>
                <div className="handle-line">第 {rectifyNow || '____'} 项建议当场改正。</div>
                <div className="handle-line">
                    第 {rectifyLater || '____'} 项建议于 {dateText || '____ 年 ____ 月 ____ 日'} 前改正。
                </div>
                <div className="handle-line">第 {transfer || '____'} 项移交相关职能部门处理。</div>
            </>
        );
    })();

    /** ================= 表头两项 ================= */

    const building = finalChecklist.find(i => i.title === '所在建筑类型');
    const nature = finalChecklist.find(i => i.title === '单位(场所)性质');

    return (
        <div className="print-page">
            <div className="title">
                朱家角镇消防安全管理巡查记录单
                <span className="code">{recordData.code}</span>
            </div>

            <table className="main-table">
                <tbody>
                    <tr>
                        <td colSpan="3">
                            被巡查单位（场所）名称：{recordData.companyInfo.companyName}
                        </td>
                        <td colSpan="2">
                            消防安全责任人：{recordData.companyInfo.safetyName}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">地址：{recordData.companyInfo.address}</td>
                        <td colSpan="2">电话：{recordData.companyInfo.safetyTel}</td>
                    </tr>

                    {/* 所在建筑类型 */}
                    <tr>
                        <td colSpan="5">
                            所在建筑类型：
                            {building && renderOptions(building)}

                            {building?.descFlag && building?.description && (
                                <span className="remark">（备注：{building.description}）</span>
                            )}
                        </td>
                    </tr>

                    {/* 单位（场所）性质 */}
                    <tr>
                        <td colSpan="5">
                            单位（场所）性质：
                            {nature && renderOptions(nature)}

                            {nature?.descFlag && nature?.description && (
                                <span className="remark">（备注：{nature.description}）</span>
                            )}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="5" className="section-title">
                            巡查内容及存在隐患
                        </td>
                    </tr>

                    {finalChecklist
                        .filter(
                            item =>
                                item.title !== '所在建筑类型' &&
                                item.title !== '单位(场所)性质'
                        )
                        .map((item, index) => (
                            <tr key={item.title}>
                                <td colSpan="5">
                                    {index + 1}、{item.title}：
                                    {renderOptions(item)}

                                    {/* 抽查部位 */}
                                    {item.ispart && (
                                        <span className="remark">抽查部位：{item.partText ? (
                                            <span className="underline">{item.partText}</span>
                                        ) : (
                                            "_______________"
                                        )}</span>
                                    )}

                                    {/* 备注 */}
                                    {item.descFlag && (
                                        <span className="remark">{item.description ? (
                                            <span className="underline">{item.description}</span>
                                        ) : (
                                            "_______________"
                                        )}</span>
                                    )}
                                </td>
                            </tr>
                        ))}


                    <tr>
                        <td colSpan="5" className="handle-box">
                            {handleText}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            负责人（签收人）：
                            {recordData.checklist?.[0]?.compamy_sign && (
                                <img
                                    className="qmimg"
                                    src={CONF.imgPrefix + recordData.checklist[0].compamy_sign}
                                    alt=""
                                />
                            )}
                            <span className="date">
                                {moment(recordData.checklist?.[0]?.createdAt).format('YYYY年MM月DD日')}
                            </span>
                        </td>

                        <td colSpan="2">
                            巡查人（签名）：
                            {recordData.checklist?.[0]?.jc_signature && (
                                <img
                                    className="qmimg"
                                    src={CONF.imgPrefix + recordData.checklist[0].jc_signature}
                                    alt=""
                                />
                            )}
                            {recordData.checklist?.[0]?.jz_signature && (
                                <img
                                    className="qmimg"
                                    src={CONF.imgPrefix + recordData.checklist[0].jz_signature}
                                    alt=""
                                />
                            )}
                            <span className="date">
                                {moment(recordData.checklist?.[0]?.createdAt).format('YYYY年MM月DD日')}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="footer">
                （本消防安全管理巡查记录单一式二联，第一联镇消防安全委，第二联移交相关执法部门）
            </div>
        </div>
    );
};

export default PrintSafetyRecord;
